import { alpha, Box, Input, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import ReactSelect from 'components/common/react-select/ReactSelect';
import { getAppBuilderCurrentStyleValue } from 'app/app/editor/tabs/settings/style-editor/StylesEditorContainer';
import { StaticAddon } from 'components/common/static-addon/StaticAddon';

interface SizeFieldProps {
    formState: any;
    propertyName: string;
    onChangeStyle: (value: any) => void;
    uid: string;
}

const sizeTypeOptionsList = [
    {
        label: 'Fill',
        value: 'fill',
    },
    {
        label: 'Relative',
        value: 'relative',
    },
    {
        label: 'Fixed',
        value: 'fixed',
    },
    {
        label: 'Fit Content',
        value: 'auto',
    },
];
export default function SizeField({ propertyName, formState, onChangeStyle = () => {}, uid }: SizeFieldProps) {
    const [currentSizeType, setCurrentSizeType] = useState<string>('fill');
    const sizeTypePropertyName = 'size-type-' + propertyName;

    useEffect(() => {
        const sizeType = getAppBuilderCurrentStyleValue(formState, sizeTypePropertyName);
        setCurrentSizeType(sizeType);
    }, [getAppBuilderCurrentStyleValue(formState, sizeTypePropertyName)]);

    const handleChangeSizeType = (value: any) => {
        setCurrentSizeType(value);
        let sizeValue = '';
        const element = document.querySelector('[data-uid="' + uid + '"]');

        switch (value) {
            case 'fill':
                break;
            case 'fixed':
                if (element) {
                    sizeValue =
                        Math.floor(element.getBoundingClientRect()[propertyName == 'height' ? 'height' : 'width']) +
                        'px';
                }
                break;
            case 'relative':
                if (element && element.parentElement) {
                    sizeValue =
                        Math.floor(
                            (element.getBoundingClientRect()[propertyName == 'height' ? 'height' : 'width'] /
                                (element.parentElement.getBoundingClientRect()[
                                    propertyName == 'height' ? 'height' : 'width'
                                ] -
                                    22)) *
                                100,
                        ) + '%';
                }
                break;
            case 'auto':
                break;
        }
        onChangeStyle({
            [sizeTypePropertyName]: value,
            [propertyName]: sizeValue,
        });
    };

    const getValue = () => {
        if (currentSizeType == 'fill') return 1;
        if (currentSizeType == 'auto') return 'auto';
        return getAppBuilderCurrentStyleValue(formState, propertyName).replace('px', '').replace('%', '');
    };

    const changeSizeVal = (e: any) => {
        if (currentSizeType == 'fixed') onChangeStyle({ [propertyName]: e.target.value + 'px' });
        if (currentSizeType == 'relative') onChangeStyle({ [propertyName]: e.target.value + '%' });
    };
    return (
        <Stack direction={'row'} spacing={1}>
            <Stack direction="row" sx={{ flexGrow: 1 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Input
                        fullWidth
                        value={getValue()}
                        onChange={changeSizeVal}
                        readOnly={currentSizeType == 'fill' || currentSizeType == 'auto'}
                        sx={
                            currentSizeType == 'fill' || currentSizeType == 'auto'
                                ? {
                                      backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.0426),
                                      pointerEvents: 'none',
                                      '.MuiInputBase-input': {
                                          color: (theme) => alpha(theme.palette.text.primary, 0.6),
                                      },
                                  }
                                : {}
                        }
                    />
                </Box>
                {currentSizeType != 'auto' && (
                    <StaticAddon place={'end'}>
                        <Box sx={{ width: '16px', textAlign: 'center' }}>
                            {currentSizeType == 'fill' && 'fr'}
                            {currentSizeType == 'relative' && '%'}
                            {currentSizeType == 'fixed' && 'px'}
                        </Box>
                    </StaticAddon>
                )}
            </Stack>

            <Box sx={{ width: '125px', flexShrink: 0 }}>
                <ReactSelect data={sizeTypeOptionsList} value={[currentSizeType]} update={handleChangeSizeType} />
            </Box>
        </Stack>
    );
}
